import React, { ReactElement } from 'react'
import { Svg, Button } from 'ui'
import { Text } from 'theme-ui'
import WatchIcon from 'images/dashboard/checklist/watch-icon.svg'
import { setIsMobileNavMenuOpen, setIsOnboardVideoVisible } from 'store/dashboard/dashboard'
import { useAppDispatch } from 'store/hooks'
import useBreakpointIndex from 'ui/Theme/useBreakpointIndex'

export default function CheckWatchTutorialButton(): ReactElement {
  const dispatch = useAppDispatch()
  const isMobile = useBreakpointIndex() === 0

  return (
    <Button
      ariaLabel="Watch Tutorial"
      variant="simple"
      data-testid="watch-tutorial-button"
      onClick={() => {
        dispatch(setIsOnboardVideoVisible(true))

        if (isMobile) {
          dispatch(setIsMobileNavMenuOpen(false))
        }
      }}
      sx={{
        width: '100%',
        height: '3.6rem',
        borderRadius: '10rem',
        backgroundColor: 'white6',
        gap: '0.8rem',
        px: '1.6rem',
        svg: {
          '& circle': {
            stroke: 'aliceBlue60',
          },
          '& path': {
            fill: 'aliceBlue60',
          },
        },
      }}
    >
      <Svg svg={WatchIcon} descriptiveText="Watch Tutorial" />
      <Text
        variant="size14Weight700"
        sx={{
          color: 'aliceBlue60',
        }}
      >
        Watch a Tutorial
      </Text>
    </Button>
  )
}
